// Every language the console can add: the ISO 639-1 languages, plus Filipino and Central
// Kurdish (three-letter codes). Names come from the browser, in English and in the
// language itself, so none are typed here.

const CODES = [
  'af', 'ak', 'am', 'ar', 'as', 'az', 'be', 'bg', 'bm', 'bn', 'bo', 'bs', 'ca', 'ckb', 'cs', 'cy', 'da', 'de', 'dz', 'ee', 'el', 'en',
  'es', 'et', 'eu', 'fa', 'ff', 'fi', 'fil', 'fo', 'fr', 'fy', 'ga', 'gd', 'gl', 'gu', 'ha', 'he', 'hi', 'hr', 'ht', 'hu', 'hy', 'id',
  'ig', 'is', 'it', 'ja', 'jv', 'ka', 'kk', 'km', 'kn', 'ko', 'ks', 'ku', 'ky', 'lb', 'lg', 'ln', 'lo', 'lt', 'lu', 'lv', 'mg', 'mi',
  'mk', 'ml', 'mn', 'mr', 'ms', 'mt', 'my', 'nb', 'ne', 'nl', 'nn', 'ny', 'om', 'or', 'pa', 'pl', 'ps', 'pt', 'qu', 'rm', 'rn', 'ro',
  'ru', 'rw', 'sa', 'sd', 'se', 'sg', 'si', 'sk', 'sl', 'sm', 'sn', 'so', 'sq', 'sr', 'st', 'su', 'sv', 'sw', 'ta', 'te', 'tg', 'th',
  'ti', 'tk', 'tn', 'to', 'tr', 'ts', 'tt', 'ug', 'uk', 'ur', 'uz', 've', 'vi', 'wo', 'xh', 'yi', 'yo', 'zh', 'zu',
];

const english = new Intl.DisplayNames(['en'], { type: 'language', fallback: 'none' });

/** "Portuguese" */
export const englishName = (code: string): string => english.of(code) ?? code;

/** "Português": the language's name in itself, capitalised. */
export function ownName(code: string): string {
  try {
    const name = new Intl.DisplayNames([code], { type: 'language', fallback: 'none' }).of(code) ?? englishName(code);
    return name.charAt(0).toLocaleUpperCase(code) + name.slice(1);
  } catch {
    return englishName(code);
  }
}

/** Every language the browser can name, by English name. */
export const ALL_LANGUAGES: { code: string; english: string; own: string }[] = CODES.filter((c) => english.of(c) !== undefined)
  .map((code) => ({ code, english: englishName(code), own: ownName(code) }))
  .sort((a, b) => a.english.localeCompare(b.english));

/** English first, then Arabic, then the rest by English name. */
export const byUsualOrder = (a: string, b: string): number => {
  const rank = (l: string) => (l === 'en' ? 0 : l === 'ar' ? 1 : 2);
  return rank(a) - rank(b) || englishName(a).localeCompare(englishName(b));
};

/** "English, Arabic and Portuguese" */
export function languageList(codes: string[]): string {
  const names = [...codes].sort(byUsualOrder).map(englishName);
  return names.length <= 1 ? (names[0] ?? '') : `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}`;
}
